import { render } from "./ImportReportContacts.vue?vue&type=template&id=4ab8fd05&scoped=true"
import script from "./ImportReportContacts.vue?vue&type=script&lang=ts"
export * from "./ImportReportContacts.vue?vue&type=script&lang=ts"

import "./ImportReportContacts.vue?vue&type=style&index=0&id=4ab8fd05&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4ab8fd05"

export default script